import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Flex } from 'antd';

type Props = {
  visible: boolean;
  generating: boolean;
  generateDisabled: boolean;
  onGenerate: () => void;
  onCancel: () => void;
};

const FilesSelectionBar = ({
  visible,
  generating,
  generateDisabled,
  onGenerate,
  onCancel,
}: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="files-page__selection-bar">
      <Flex
        className="files-page__selection-bar-inner"
        align="center"
        wrap
        gap={20}
      >
        <Button
          type="primary"
          className="files-page__selection-generate-btn"
          loading={generating}
          disabled={generating || generateDisabled}
          onClick={onGenerate}
        >
          <FormattedMessage id="files.selection.generateNeuro" />
        </Button>
        <Button
          className="files-page__selection-cancel-btn"
          disabled={generating}
          onClick={onCancel}
        >
          <FormattedMessage id="files.uploadModal.cancel" />
        </Button>
      </Flex>
    </div>
  );
};

export default FilesSelectionBar;
